var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v("Add New Subdomain")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c("gg-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      label: "Subdomain name",
                      placeholder: "Enter a new subdomain",
                      name: "Subdomain name",
                      "error-messages": _vm.errors.collect("Subdomain name")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "append",
                        fn: function fn() {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "append-bg"
                              },
                              [
                                _c("domain-select", {
                                  attrs: {
                                    name: "Root Domain",
                                    "no-label": "",
                                    "hide-details": "",
                                    solo: "",
                                    flat: "",
                                    "error-messages": _vm.errors.collect(
                                      "Root Domain"
                                    ),
                                    remote_domain: _vm.model.rootdomain
                                  },
                                  model: {
                                    value: _vm.model.rootdomain,
                                    callback: function callback($$v) {
                                      _vm.$set(_vm.model, "rootdomain", $$v)
                                    },
                                    expression: "model.rootdomain"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.model.domain,
                      callback: function callback($$v) {
                        _vm.$set(_vm.model, "domain", $$v)
                      },
                      expression: "model.domain"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "gg-btn",
            {
              attrs: {
                primary: "",
                loading: _vm.button.loading
              },
              on: {
                click: _vm.addSubdomain
              }
            },
            [_vm._v("Create Subdomain")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }